import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to delete the teacher by the teacher id
 */
export const useDeleteTeacher = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const { axiosInstance } = useAxios();

    /**
     * @param {string} teacherId
     * @param {() => void} [onSuccess] - Optional callback on successful delete
     */
    const deleteTeacher = async (teacherId, onSuccess) => {
        try {
            setLoading(true);
            setError("");
            setSuccess(false);
            await axiosInstance.delete(
                `${TENANT_DOMAIN}/school/admin/teacher/destroy/${teacherId}`,
            );
            setSuccess(true);
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            setSuccess(false);
            if (error.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    const resetState = () => {
        setError("");
        setSuccess(false);
    };

    return { deleteTeacher, loading, error, success, resetState };
};